import { Paper, Grid2, Typography } from '@mui/material'
import React, { useEffect, useState, useCallback } from 'react'
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import moment from 'moment';

// componentes
import BtnAcciones from '../../../components/plantilla/tabla/BtnAcciones';
import ModalUbicacion from './modales/ModalUbicacion';
import MiTabla from '../../../components/plantilla/tabla/MiTabla'
import useMediaQuery from '@mui/material/useMediaQuery';

// Iconos
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';

function DashboardAlertas() {

    const isNonMobile = useMediaQuery("(min-width:600px)");


    const [dataTk, setDataTk] = useState([]);
    const [modalMapsOpen, setModalMapsOpen] = useState(false);
    const [selectedAlert, setSelectedAlert] = useState(null);

    const handleOpenModalUbicacion = (alert = null) => {
        console.log(alert);
        setSelectedAlert(alert);
        setModalMapsOpen(true);
    };

    const columnsTk = [
        {
            field: 'vehicleName', headerName: 'Vehículo', flex: 1, headerAlign: "center",
            align: "center",
        },
        {
            field: 'alarmCode', headerName: 'Código de alarma', flex: 1, headerAlign: "center",
            align: "center",
        },
        {
            field: 'alarmDescription', headerName: 'Descripción de alarma', flex: 1, headerAlign: "center",
            align: "center",
        },
        {
            field: 'firstOccurrence', headerName: 'Fecha de detección Inicial (DD/MM/YYYY)', flex: 1, headerAlign: "center",
            align: "center", valueFormatter: (value) => {
                return moment(value).format('DD/MM/YYYY HH:mm');
            }
        },
        {
            field: 'lastOccurrence', headerName: 'Fecha de detección actual (DD/MM/YYYY)', flex: 1, headerAlign: "center",
            align: "center", valueFormatter: (value) => {
                return moment(value).format('DD/MM/YYYY HH:mm');
            }
        },
        {
            field: 'totalOccurrences', headerName: 'Total de detecciones', flex: 1, headerAlign: "center",
            align: "center"
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 150,
            getActions: (params) => [
                <BtnAcciones
                    icon={<GpsFixedIcon />}
                    label="Ubicación"
                    onClick={() => handleOpenModalUbicacion(params.row)}
                />,
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                />,
                <BtnAcciones
                    icon={<DeleteIcon />}
                    label="Eliminar"
                />
            ],
        }

    ];

    const getAlertas = async () => {
        try {
            const responseTk = await myApi.get('/monitoreo/alertas/getAlertasTK');
            if (responseTk.data.success) {
                setDataTk(responseTk.data.data);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al obtener las alertas',
                });
                setDataTk([]);
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al obtener las alertas',
            });
        }
    };

    useEffect(() => {
        getAlertas();
    }, []);
    return (
        <Paper sx={{ padding: 2 }} elevation={2}>
            <Grid2 container>
                <Grid2 item size={{ xs: 12, md: 12 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Dashboard de Alertas
                    </Typography>
                </Grid2>

                <Grid2 item size={{ xs: 12, md: 12 }} sx={{
                    display: 'flex',
                    justifyContent: isNonMobile ? 'flex-end' : 'start'
                }}>
                    <Grid2 size={{ xs: 12 }}>
                        <MiTabla
                            columns={columnsTk}
                            data={dataTk}
                        />
                    </Grid2>
                </Grid2>

                <ModalUbicacion
                    open={modalMapsOpen}
                    onClose={() => setModalMapsOpen(false)}
                    data={selectedAlert}
                />
            </Grid2>
        </Paper>
    )
}

export default DashboardAlertas